import React,{useState} from 'react';
import pp from "../assets/cagla_logo 1.svg"
import { useNavigate } from "react-router-dom";
import Footer from './Footer';
const Navbar = (props) => {
  let navigate = useNavigate(); 
  const routeChange = () =>{ 
    let path = `newPath`; 
    navigate("/about");
  }
  const routeProject = () =>{ 
    let path = `newPath`; 
    navigate("/projects");
  }
  const routeWrite = () =>{ 
    let path = `newPath`; 
    navigate("/writes");
  }
  const routeResume = () =>{ 
    let path = `newPath`; 
    navigate("/resume");
  }
  const routeHome = () =>{ 
    let path = `newPath`; 
    navigate("/");
  }
const [nav,setNav] = useState(false)
const handleClick = ()=> setNav(!nav)
const handleClose=()=> setNav(!nav)
  return (
    <div className='w-screen py-7'> 
      <div className='px-[16px] md:px-[70px] lg:px-[150px]  flex items-center w-full h-full justify-between'>
        <div onClick={routeHome} className='flex items-center cursor-pointer'>
          <img className='w-[80px] border-1' src={pp} alt="" />
          <h1 className={`text-2xl font-bold mr-4 leading-[28.2px] w-[100px] ml-5 ${props.renk}`}>ÇAĞLA ÜNSAL</h1>
        </div>
        <div>
          <ul className={`hidden md:flex`}>
            <li className={`cursor-pointer ${props.renk2}`} onClick={routeChange}>Hakkımda</li>
            <li className={`cursor-pointer ${props.renk2}`} onClick={routeProject}>Projelerim</li>
            <li className={`cursor-pointer ${props.renk2}`} onClick={routeWrite}>Yazılarım</li>
            <li className={`cursor-pointer ${props.renk2}`} onClick={routeResume}>Özgeçmiş</li>
          </ul>
        </div>
     <div className='md:hidden' onClick={handleClick}>
                {!nav ? <a className={` ${props.renk}`}><ion-icon size="large" name="menu-outline"></ion-icon></a>:<a className={` ${props.renk}`}><ion-icon size="large"  name="close-outline"></ion-icon></a> }    
            </div>
            
      </div>
      <ul className={!nav ? 'hidden' : `absolute bg z-10 w-full h-[80%] ${props.bgrenk} text-2xl pt-[20px] px-[15px]`} >
            <li onClick={routeHome} className={`cursor-pointer ${props.renk2}`}><a onClick={handleClose} href="">Anasayfa</a></li>
            <li onClick={routeChange}  className={`cursor-pointer ${props.renk2}`}><a onClick={handleClose} href="">Hakkımda</a></li>
            <li onClick={routeProject}  className={`cursor-pointer ${props.renk2}`}><a onClick={handleClose} href="">Projelerim</a></li>
            <li onClick={routeWrite}  className={`cursor-pointer ${props.renk2}`}><a onClick={handleClose} href="">Yazılarım</a></li>
            <li  onClick={routeResume} className={`cursor-pointer ${props.renk2}`}><a onClick={handleClose} href="">Özgeçmiş</a></li>
        </ul> 
    </div>
  )
}

export default Navbar